export const companyName =
    process.env.NEXT_PUBLIC_PROJECT_NAME === 'epncpa' ? 'e-Commerce Partners Network' : 'ePN';

export const isGlobalDomain = process.env.NEXT_PUBLIC_PROJECT_NAME === 'epncpa';
